import { RescueArea } from '@twiceme-technology/api-types/v1/types'

import { useEffect, useState } from 'react'
import { getRescueAreasWithinRadius } from '../api/rescue-areas/get-rescue-areas-within-radius'

interface LocalRescueAreaNumber {
  name: string
  number: string
}

export const useLocalEmergencyPhoneNumber = () => {
  const [isLoading, setIsLoading] = useState(false)
  const [error, setError] = useState<unknown>(null)
  const [localRescueAreaNumbers, setLocalRescueAreaNumbers] = useState<
    LocalRescueAreaNumber[]
  >([])
  const [position, setPosition] = useState<GeolocationPosition>()

  useEffect(() => {
    getLocalEmergencyPhoneNumber()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  const getLocalEmergencyPhoneNumber = async () => {
    setIsLoading(true)
    setError(null)
    try {
      navigator.geolocation.getCurrentPosition(
        (position) => {
          setPosition(position)
        },
        (error) => {
          console.error(error)
        },
        {
          enableHighAccuracy: false,
        }
      )

      if (!position) {
        setError(new Error('No position found'))
        return
      }
      const rescueAreas = await getRescueAreasWithinRadius({
        latitude: position.coords.latitude,
        longitude: position.coords.longitude,
        radiusInKm: 1,
      })

      const numbers: LocalRescueAreaNumber[] = []
      rescueAreas.forEach((area: RescueArea) => {
        if (area.rescuePhone) {
          numbers.push({
            name: area.name,
            number: area.rescuePhone,
          })
        }

        area.subAreas.forEach((subArea) => {
          if (subArea.phone) {
            numbers.push({
              name: subArea.name,
              number: subArea.phone,
            })
          }
        })
      })

      setLocalRescueAreaNumbers(numbers)
    } catch (error) {
      setError(error)
    } finally {
      setIsLoading(false)
    }
  }

  return {
    localRescueAreaNumbers,
    isLoading,
    error,
  }
}
